export const EDITABLE_FORM_NAME = 'editableForm';
export const PAYMENT_FORM_NAME = 'paymentForm';
export const RESUME_BUILDER_FORM_NAME = 'builderFormV2';
